module.exports = __webpack_public_path__ + "static/media/kmBar.4849be2b.svg";